// extracted by mini-css-extract-plugin
module.exports = {"Heading":"AddMember_Heading__1l72l","Footer":"AddMember_Footer__GfMYv"};